import Cookies from 'js-cookie';

class CookieService {
    static set = (key, value, expires = 365) => {
        Cookies.set(key, JSON.stringify(value), {
            expires,
        });
    };

    static get = (key) => {
        const value = Cookies.get(key);

        return value;
    }
}

export default CookieService;
